// extracted by mini-css-extract-plugin
module.exports = {"carouselContent":"LinkedInTestimonialsContent_carouselContent__kq5c9"};